// Author YuJiaBei
// Date 2021-06-23 11:44:36

class SithMesMstBom {
        constructor({
                id = null,
                parentId = '',
                component = '',
                level = '',
                item = '',
                qty = '',
                baseQuantity = '',
                bomUnit = '',
                stockUnit = '',
                ipt = '',
                pdt = '',
                chineseName = '',
                englishName = '',
                longText = '',
                mtype = '',
                eF = '',
                itemText = '',
                ict = '',
                mrp = '',
                remark = '',
                seq = '',
                name = ''}
        = {}) {
            this.id = id;
            this.parentId = parentId;
            this.component = component;
            this.level = level;
            this.item = item;
            this.qty = qty;
            this.baseQuantity = baseQuantity;
            this.bomUnit = bomUnit;
            this.stockUnit = stockUnit;
            this.ipt = ipt;
            this.pdt = pdt;
            this.chineseName = chineseName;
            this.englishName = englishName;
            this.longText = longText;
            this.mtype = mtype;
            this.eF = eF;
            this.itemText = itemText;
            this.ict = ict;
            this.mrp = mrp;
            this.remark = remark;
            this.seq = seq;
            this.name = name;
        }
        }
        
        function newEntity() {
        return new SithMesMstBom();
        }
        
            function gridFields() {
            return Object.freeze([
                {
                key: 'parentId',
                label: 'label.sith.mst.sithMesMstBom.grid.parentId',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'component',
                label: 'label.sith.mst.sithMesMstBom.grid.component',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'level',
                label: 'label.sith.mst.sithMesMstBom.grid.level',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'item',
                label: 'label.sith.mst.sithMesMstBom.grid.item',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'qty',
                label: 'label.sith.mst.sithMesMstBom.grid.qty',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'baseQuantity',
                label: 'label.sith.mst.sithMesMstBom.grid.baseQuantity',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bomUnit',
                label: 'label.sith.mst.sithMesMstBom.grid.bomUnit',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'stockUnit',
                label: 'label.sith.mst.sithMesMstBom.grid.stockUnit',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'ipt',
                label: 'label.sith.mst.sithMesMstBom.grid.ipt',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'pdt',
                label: 'label.sith.mst.sithMesMstBom.grid.pdt',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'chineseName',
                label: 'label.sith.mst.sithMesMstBom.grid.chineseName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'englishName',
                label: 'label.sith.mst.sithMesMstBom.grid.englishName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'longText',
                label: 'label.sith.mst.sithMesMstBom.grid.longText',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'mtype',
                label: 'label.sith.mst.sithMesMstBom.grid.mtype',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'eF',
                label: 'label.sith.mst.sithMesMstBom.grid.eF',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'itemText',
                label: 'label.sith.mst.sithMesMstBom.grid.itemText',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'ict',
                label: 'label.sith.mst.sithMesMstBom.grid.ict',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'mrp',
                label: 'label.sith.mst.sithMesMstBom.grid.mrp',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'remark',
                label: 'label.sith.mst.sithMesMstBom.grid.remark',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'textarea'
                }
                },
                {
                key: 'seq',
                label: 'label.sith.mst.sithMesMstBom.grid.seq',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'nodeCode',
                label: 'label.sith.mst.sithMesMstBom.grid.nodeCode',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'name',
                label: 'label.sith.mst.sithMesMstBom.grid.name',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'parentName',
                label: 'label.sith.mst.sithMesMstBom.grid.parentName',
                sortable: true,
                form: {
                type: 'input'
                }
                }
            ])}
        
        const filter = {
            idFilter : "",
            idListFilter : "",
            parentIdFilter : "",
            componentFilter : "",
            levelFilter : "",
            itemFilter : "",
            qtyFilter : "",
            bomUnitFilter : "",
            stockUnitFilter : "",
            iptFilter : "",
            pdtFilter : "",
            chineseNameFilter : "",
            englishNameFilter : "",
            longTextFilter : "",
            mtypeFilter : "",
            eFFilter : "",
            itemTextFilter : "",
            ictFilter : "",
            mrpFilter : "",
            nodeCodeFilter : "",
            nameFilter : "",
            parentNameFilter : ""
        };
        
        const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
        
        const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
        
        const filterConfigs = [
                {
                key: 'parentIdFilter',
                label: 'label.sith.mst.sithMesMstBom.filter.parentId',
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'componentFilter',
                label: 'label.sith.mst.sithMesMstBom.filter.component',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'levelFilter',
                label: 'label.sith.mst.sithMesMstBom.filter.level',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'itemFilter',
                label: 'label.sith.mst.sithMesMstBom.filter.item',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'qtyFilter',
                label: 'label.sith.mst.sithMesMstBom.filter.qty',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'bomUnitFilter',
                label: 'label.sith.mst.sithMesMstBom.filter.bomUnit',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'stockUnitFilter',
                label: 'label.sith.mst.sithMesMstBom.filter.stockUnit',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'iptFilter',
                label: 'label.sith.mst.sithMesMstBom.filter.ipt',
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'pdtFilter',
                label: 'label.sith.mst.sithMesMstBom.filter.pdt',
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'chineseNameFilter',
                label: 'label.sith.mst.sithMesMstBom.filter.chineseName',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'englishNameFilter',
                label: 'label.sith.mst.sithMesMstBom.filter.englishName',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'longTextFilter',
                label: 'label.sith.mst.sithMesMstBom.filter.longText',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'mtypeFilter',
                label: 'label.sith.mst.sithMesMstBom.filter.mtype',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'eFFilter',
                label: 'label.sith.mst.sithMesMstBom.filter.eF',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'itemTextFilter',
                label: 'label.sith.mst.sithMesMstBom.filter.itemText',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'ictFilter',
                label: 'label.sith.mst.sithMesMstBom.filter.ict',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'mrpFilter',
                label: 'label.sith.mst.sithMesMstBom.filter.mrp',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'nodeCodeFilter',
                label: 'label.sith.mst.sithMesMstBom.filter.nodeCode',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'nameFilter',
                label: 'label.sith.mst.sithMesMstBom.filter.name',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'parentNameFilter',
                label: 'label.sith.mst.sithMesMstBom.filter.parentName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'sithMesMstBom'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"parentId":"id"}'
                        }
                }
        ];
        
        
            const entityFormConfigs = [
                {
                key: 'parentId',
                label: 'label.sith.mst.sithMesMstBom.entity.parentId',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'component',
                label: 'label.sith.mst.sithMesMstBom.entity.component',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'level',
                label: 'label.sith.mst.sithMesMstBom.entity.level',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'item',
                label: 'label.sith.mst.sithMesMstBom.entity.item',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'qty',
                label: 'label.sith.mst.sithMesMstBom.entity.qty',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'baseQuantity',
                label: 'label.sith.mst.sithMesMstBom.entity.baseQuantity',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'bomUnit',
                label: 'label.sith.mst.sithMesMstBom.entity.bomUnit',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'stockUnit',
                label: 'label.sith.mst.sithMesMstBom.entity.stockUnit',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'ipt',
                label: 'label.sith.mst.sithMesMstBom.entity.ipt',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'pdt',
                label: 'label.sith.mst.sithMesMstBom.entity.pdt',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'chineseName',
                label: 'label.sith.mst.sithMesMstBom.entity.chineseName',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'englishName',
                label: 'label.sith.mst.sithMesMstBom.entity.englishName',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'longText',
                label: 'label.sith.mst.sithMesMstBom.entity.longText',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'mtype',
                label: 'label.sith.mst.sithMesMstBom.entity.mtype',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'eF',
                label: 'label.sith.mst.sithMesMstBom.entity.eF',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'itemText',
                label: 'label.sith.mst.sithMesMstBom.entity.itemText',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'ict',
                label: 'label.sith.mst.sithMesMstBom.entity.ict',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'mrp',
                label: 'label.sith.mst.sithMesMstBom.entity.mrp',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'remark',
                label: 'label.sith.mst.sithMesMstBom.entity.remark',
                sortable: true,
                disabled: false,
                form: {
                type: 'textarea'
                        }
                },
                {
                key: 'seq',
                label: 'label.sith.mst.sithMesMstBom.entity.seq',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'name',
                label: 'label.sith.mst.sithMesMstBom.entity.name',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                    ,required: true
                        }
                }
        ]
        
        export {SithMesMstBom, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
        , filterConfigs
        
        
        }
        